const isNumber = (value: string | number) => {
	if (value == undefined) return false
	return /[0-9]/.test(value.toString())
}

export default isNumber
